(function() {
    'use strict';

    angular.module('substoreApp.services')
        .service('sessionData', sessionDataService);

    var data = null;

    function sessionDataService($q, $cookies, $log) {

        var deferred = $q.defer();
        data = data || {
            sessionId: null,
            csrfProtectionToken: null,
            dialogStaticData: {
                language: null,
                availableLanguages: null,
                showCatalogue: null,
                showMyProducts: null,
                exemptedFromTax: null,
                invokingPortal: null,
                identifierType: null,
                msisdn: null,
                natCoName: null,
                wholesalePartnerId: null,
                dev: null,
                customResources: null,
                enableWebtrekkIntegration: false,
                webtrekkTealiumURL: null
            },
            fault: null,
            promise: deferred.promise,
            transient: {
                pendingRequests: 0,
                isLoading: false,
                orderCallId: null,
                subscriptionTemplateId: null,
                deeplinkedPage: null
            },
            notifyDataAvailable: function () {
                deferred.resolve(true)
            },
            hasFault: function () {
                return data.fault && data.fault.code;
            },
            resetFault: function () {
                data.fault = null;
            },
            storeSessionData: function () {
                var storedData = {
                    sessionId: data.sessionId,
                    csrfProtectionToken: data.csrfProtectionToken,
                    lang: data.dialogStaticData ? data.dialogStaticData.language : null,
                    wpId: data.dialogStaticData ? data.dialogStaticData.wholesalePartnerId : null,
                };
                $cookies.putObject("dtag-cap-substore", storedData, {path: '/'});
            },
            loadSessionData: function () {
                var storedData = $cookies.getObject("dtag-cap-substore", {path: '/'});
                if (storedData) {
                    data.sessionId = storedData.sessionId;
                    data.csrfProtectionToken = storedData.csrfProtectionToken;
                    if (!data.dialogStaticData) data.dialogStaticData = {};
                    data.dialogStaticData.language = storedData.lang;
                    data.dialogStaticData.wholesalePartnerId = storedData.wpId;
                    return true;
                } else {
                    return false;
                }
            },
            deleteSessionData: function () {
                data.sessionId = undefined;
                data.dialogStaticData = undefined;
                this.deleteCurrentSubscription();
                this.storeSessionData();
            },
            deleteCurrentSubscription: function () {
                data.transient.subscriptionTemplateId = undefined;
                data.transient.orderCallId = undefined;
            },
            mergeWith: function (newData) {
                if (!data.dialogStaticData.language) data.dialogStaticData.language = newData.language;
                if (!data.dialogStaticData.availableLanguages) data.dialogStaticData.availableLanguages = newData.availableLanguages;
                if (!data.dialogStaticData.natCoName) data.dialogStaticData.natCoName = newData.natCoName;
                if (!data.dialogStaticData.wholesalePartnerId) data.dialogStaticData.wholesalePartnerId = newData.wholesalePartnerId;
                if (!data.dialogStaticData.dev) data.dialogStaticData.dev = newData.dev;
                if (!data.dialogStaticData.customResources) data.dialogStaticData.customResources = newData.customResources;
                if (!data.dialogStaticData.enableWebtrekkIntegration) data.dialogStaticData.enableWebtrekkIntegration = newData.enableWebtrekkIntegration;
                if (!data.dialogStaticData.webtrekkTealiumURL) data.dialogStaticData.webtrekkTealiumURL = newData.webtrekkTealiumURL;
                if (!data.dialogStaticData.showMyProducts) data.dialogStaticData.showMyProducts = newData.showMyProducts;
                if (!data.dialogStaticData.showCatalogue) data.dialogStaticData.showCatalogue = newData.showCatalogue;
                if (!data.dialogStaticData.exemptedFromTax) data.dialogStaticData.exemptedFromTax = newData.exemptedFromTax;
                if (!data.dialogStaticData.invokingPortal) data.dialogStaticData.invokingPortal = newData.invokingPortal;
                if (!data.dialogStaticData.invokingPortalKey) data.dialogStaticData.invokingPortalKey = newData.invokingPortalKey;
                if (!data.dialogStaticData.msisdn) data.dialogStaticData.msisdn = newData.msisdn;
                if (!data.dialogStaticData.identifierType) data.dialogStaticData.identifierType = newData.identifierType;
                if (!data.dialogStaticData.identifiertValuePrefix) data.dialogStaticData.identifiertValuePrefix = newData.identifiertValuePrefix;
                if (!data.dialogStaticData.hideIdentifierValue) data.dialogStaticData.hideIdentifierValue = newData.hideIdentifierValue;
            },
            log: function () {
                this.sessionId && $log.debug("sessionData.sessionId=" + this.sessionId);
                this.dialogStaticData && $log.debug("sessionData.dialogStaticData=" + this.dialogStaticData);
                this.fault && $log.debug("sessionData.fault=" + this.fault);
                this.transient.pendingRequests && $log.debug("sessionData.transient.pendingRequests=" + this.transient.pendingRequests);
                this.transient.isLoading && $log.debug("sessionData.transient.isLoading=" + this.transient.isLoading);
                this.transient.orderCallId && $log.debug("sessionData.transient.orderCallId=" + this.transient.orderCallId);
                this.transient.subscriptionTemplateId && $log.debug("sessionData.transient.subscriptionTemplateId=" + this.transient.subscriptionTemplateId);
            }
        };
        return data;
    }
})();